import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CardActionArea, CardContent, Grid, Stack, Typography, useTheme } from "@mui/material";
import { MprcCard } from "components";
import React from "react";

export interface IProps {
    icon: IconDefinition;
    value: number;
    valueFormated: string;
    valueDescription?: React.ReactNode;
    footer?: React.ReactNode;
    color: MprcColors;
    iconColor?: MprcColors;
    active?: boolean;
    onClick: () => void;
}

export const DashCardSelect: React.FC<IProps> = ({ icon, color, iconColor, valueFormated, valueDescription, footer, active, onClick }) => {

    const theme = useTheme();

    return (
        <MprcCard sx={{ width: "324px", height: "112px" }}>
            <CardActionArea
                onClick={onClick}
                data-active={active ? '' : undefined}
                sx={{
                    height: '100%',
                    '&[data-active]': {
                        backgroundColor: theme.palette.notice.light,
                        '&:hover': {
                            backgroundColor: 'action.selectedHover',
                        },
                    },
                }}
            >
                <CardContent>
                    <Grid container justifyContent="flex-start" alignItems="center" spacing={1} ml={1}>
                        <Grid width="80px" alignItems="center" justifyContent="center">
                            <Typography color={iconColor ?? color}>
                                <FontAwesomeIcon icon={icon} size="5x" />
                            </Typography>
                        </Grid>
                        <Grid size="grow" width="100%">
                            <Stack direction="column" alignItems="center" justifyContent="end" width="100%" spacing={1}>
                                <Typography component="div" fontSize={32} color={color}><b>{valueFormated}</b></Typography>
                                <Stack direction="column" alignItems="center" justifyContent="end" width="100%">
                                    {
                                        valueDescription &&
                                        <Typography component="div" fontSize={14} lineHeight="normal" color={color} textTransform="uppercase"><b>{valueDescription}</b></Typography>
                                    }
                                    {
                                        footer &&
                                        <Typography component="div" fontSize={12} lineHeight="normal" color={color} textTransform="uppercase">{footer}</Typography>
                                    }
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </MprcCard>
    );
};
